<script>
  import { format } from 'svelte-i18n';

  import {
    colorBackground,
    colorPrimary,
    colorSecondary,
    colorTertiary,
    colorText,
    companyName,
    fontBase,
    fontHeadings,
    fontsUrl,
    fontWeightBase,
    fontWeightHeadings,
    logoUrl
  } from '@client/stores/brand';
</script>

<svelte:head>
  {#if $fontsUrl}<link rel="stylesheet" href={$fontsUrl} />{/if}
</svelte:head>

<h2 class="pt-3 pt-sm-0 mb-3">
  {$format('label.PREVIEW')}
</h2>

<div class="frame">
  <div class="frame-content" style:background-color={$colorBackground} style:color={$colorText}>
    <header class="p-3" style:background-color={$colorPrimary} style:color={$colorBackground}>
      <h4
        class="m-0"
        style:color={$colorText}
        style:font-family={$fontHeadings || $fontBase}
        style:font-weight={$fontWeightHeadings || $fontWeightBase}
      >
        {#if $logoUrl}
          <img class="img-fluid" src={$logoUrl} alt={$format('label.LOGO')} style="height: 2rem; width: auto;" />
        {:else}
          {$companyName || $format('label.COMPANY_NAME')}
        {/if}
      </h4>
    </header>
    <div class="p-3" style:font-family={$fontBase} style:font-weight={$fontWeightBase}>
      <h1 style:font-family={$fontHeadings || $fontBase} style:font-weight={$fontWeightHeadings || $fontWeightBase}>
        {$format('label.BRAND_FONT_HEADINGS')}
      </h1>
      <p style:font-weight={$fontWeightBase}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
        magna aliqua.
      </p>
      <ul class="p-2 mt-3" style:font-weight={$fontWeightBase}>
        <li>
          <div class="swatch" style:background-color={$colorPrimary} style:color={$colorBackground} />
          {$format('label.BRAND_PRIMARY_COLOR')}
        </li>
        <li>
          <div class="swatch" style:background-color={$colorSecondary} style:color={$colorBackground} />
          {$format('label.BRAND_SECONDARY_COLOR')}
        </li>
        <li>
          <div class="swatch" style:background-color={$colorTertiary} style:color={$colorBackground} />
          {$format('label.BRAND_TERTIARY_COLOR')}
        </li>
      </ul>

      <hr />

      <button class="btn btn-md px-2" style:background-color={$colorPrimary} style:color={$colorBackground}>
        {$format('label.BUTTON')}
      </button>
    </div>
  </div>
</div>

<style lang="scss">
  .frame {
    background-color: var(--color-gray-100);
    border-radius: var(--border-radius-large);
    min-height: 55vh;
    padding: var(--padding-xlarge);

    .frame-content {
      border-radius: var(--border-radius-base);
      min-height: 52vh;

      header {
        border-radius: var(--border-radius-base) var(--border-radius-base) 0 0;
      }

      ul li {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        margin-bottom: 0.5rem;
      }

      .swatch {
        display: inline-block;
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 100%;
        margin-right: 0.5rem;
      }
    }
  }

  @media only screen and (max-height: 930px) {
    .frame {
      min-height: 53vh;

      .frame-content {
        min-height: 50vh;
      }
    }
  }

  @media only screen and (max-height: 830px) {
    .frame {
      min-height: 51vh;

      .frame-content {
        min-height: 48vh;
      }
    }
  }

  @media only screen and (max-width: 600px) {
    .frame {
      min-height: 40vh;

      .frame-content {
        min-height: 35vh;
      }
    }
  }
</style>
